<template>
    <div class="home">
        <div class="content" v-if="bankStatus === '0'">
            <div class="bind-content">
                <el-form :model="ruleForm" :rules="isReadOnly ? null : rules" ref="ruleForm" label-position="left"
                    label-width="100px" class="register-ruleForm">
                    <div class="tips-text-content">
                        <div class="tips-text">根据银联风控要求，同卡或同身份证24小时内验证不能超过4次，感谢配合！</div>
                        <div class="tips-text">北京银行、交行、邮储、平安（含原深发）、光大、兴业、浦发、东莞、中信、华夏、上海银行、农村信用合作社，以上银行卡需要先开通无卡支付功能后才能绑定。
                        </div>
                    </div>
                    <el-form-item prop="name" label="姓名" class="input-each-div" :show-message=false>
                        <el-input class="input-each" v-model="ruleForm.name" autocomplete="off"
                            :placeholder="isReadOnly ? '' : '请输入真实姓名'" :readonly="isReadOnly" maxlength="36"></el-input>
                    </el-form-item>
                    <el-form-item prop="idcard" label="身份证号" class="input-each-div" :show-message=false>
                        <el-input class="input-each" v-model="ruleForm.idcard" autocomplete="off"
                            :placeholder="isReadOnly ? '' : '请输入18位二代身份证号'" :readonly="isReadOnly" maxlength="18"></el-input>
                    </el-form-item>
                    <el-form-item prop="bankNo" label="银行卡" class="input-each-div" :show-message=false>
                        <el-input class="input-each" v-model="ruleForm.bankNo" autocomplete="off"
                            :placeholder="isReadOnly ? '' : '请输入银行卡号'" :readonly="isReadOnly" maxlength="20"></el-input>
                    </el-form-item>
                    <el-form-item prop="captcha" label="校验码" class="input-each-div" :show-message=false>
                        <el-input class="input-each" v-model="ruleForm.captcha" autocomplete="off" placeholder="请输入校验码"
                            maxlength="4"></el-input>
                        <img class="captchaImg" :src="imgsrc" @click="refreshCaptcha">
                    </el-form-item>
                    <el-form-item prop="phone" label="手机" class="input-each-div" :show-message=false>
                        <el-input class="input-each" v-model="ruleForm.phone" autocomplete="off" maxlength="11"
                            :placeholder="isReadOnly ? '' : '请输入手机号'" :readonly="isReadOnly"></el-input>
                        <div class="sendBtn" @click="checkCaptchaImg('ruleForm')">{{ second === totalSecond ?
                            '获取验证码' : second + 's后重新发送' }}</div>
                    </el-form-item>
                    <div class="input-each-div tips-div">提示：需使用对应身份证办理的国内手机号</div>
                    <el-form-item prop="code" label="验证码" class="input-each-div" :show-message=false>
                        <el-input class="input-each" v-model="ruleForm.code" autocomplete="off" placeholder="验证码"
                            maxlength="4"></el-input>
                    </el-form-item>
                    <el-form-item prop="branchName" label="开户行" class="input-each-div" :show-message=false>
                        <el-input class="input-each" v-model="ruleForm.branchName" autocomplete="off"
                            :placeholder="isReadOnly ? '' : '请输入开户行'" :readonly="isReadOnly" maxlength="36"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="all-btn" v-if="!isReadOnly">
                <div class="over-btn" @click="submitForm('ruleForm')">提交</div>
            </div>
        </div>
        <div class="content" v-if="bankStatus === '1'">
             <div class="bind-icon">
                <img src="../assets/image/bindBank-icon.png" />
                <div>绑定成功</div>
             </div>
             <div class="bind-info">
                 <div class="bind-info-detail">
                     <div class="bind-info-each">姓名：{{ bankInfo.name }}</div>
                     <div class="bind-info-each">身份证：{{ bankInfo.idcard }}</div>
                     <div class="bind-info-each">银行卡：{{ bankInfo.bankNo }}</div>
                     <div class="bind-info-each">手机号：{{ bankInfo.phone }}</div>
                     <div class="bind-info-each">开户行：{{ bankInfo.branchName }}</div>
                 </div>
                 <div class="bind-reset-btn" @click="resetBind()">重新绑定</div>
             </div>
             <div class="all-btn">
                <div class="over-btn" @click="toBack()">完成</div>
            </div>
        </div>
    </div>
</template>
<script>
import { getIdentifyCode, sendMsgCode, updateStudentRealName, getStudentBankInfo } from '@/api/common'   //路径
export default {
    name: 'PersonPage',
    props: ['id'],
    data() {
        var validatePhone = (rule, value, callback) => {
            if (value === '' || value.length < 11 || value.substring(0, 1) !== '1') {
                callback(value === '' ? new Error('请输入手机号') : new Error('手机号格式不正确'));
            } else {
                callback();
            }
        };
        var validateCaptcha = (rule, value, callback) => {
            if (rule.field === 'captcha' && value === '' && this.checkCaptcha === true) {
                callback(new Error('请输入校验码'));
            } else {
                callback();
            }
        };
        return {
            merchantId: '',
            imgsrc: '',
            bankStatus: '',
            ruleForm: {
                name: '',
                phone: '',
                idcard: '',
                bankNo: '',
                captcha: '',
                code: '',
                branchName: ''
            },
            rules: {
                name: [
                    { required: true, message: '请输入真实姓名', trigger: 'blur' }
                ],
                captcha: [
                    { required: true, validator: validateCaptcha, trigger: 'blur' }
                ],
                phone: [
                    { required: true, validator: validatePhone, trigger: 'blur' }
                ],
                idcard: [
                    { required: true, message: '请输入身份证号', trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' }
                ],
                bankNo: [
                    { required: true, message: '请输入银行卡号', trigger: 'blur' }
                ],
                branchName: [
                    { required: true, message: '请输入开户行', trigger: 'blur' }
                ],

            },
            isReadOnly: false, // true: 禁止保存 false：可保存
            buttonText: '获取验证码',
            checkCaptcha: false,
            totalSecond: 60,//总秒数
            second: 60,//倒计时的秒数
            timer: null, // 定时器 id
            bankInfo: {
                bankNo: '',
                name: '',
                branchName: '',
                phone: '',
                idcard: ''
            }
        }
    },
    mounted() {
        this.merchantId = this.id;
        this.bankStatus = this.$route.query.bankStatus;
        if (this.bankStatus === '1') {
            this.getStudentBank();
        }
        this.getIdentifyCodeImg();
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.reset();
                } else {
                    this.$message.error("请填写相关信息！");
                    return false;
                }
            });
        },
        reset() {
            let that = this;
            let params = JSON.parse(JSON.stringify(this.ruleForm));
            updateStudentRealName(params).then((res) => {
                if (res.code !== 200) {
                    that.$message.error(res.msg);
                } else {
                    that.$message({
                        duration: 1000,
                        message: '提交成功',//提示的信息
                        type: 'success',//类型是成功
                        onClose: () => {
                            that.bankStatus = '1';
                            that.getStudentBank();
                        }
                    });
                }
            })
        },
        resetBind() {
             this.bankStatus = '0';
        },
        getStudentBank() {
            let that = this;
            let params = {};
            getStudentBankInfo(params).then((res) => {
                if (res.code !== 200) {
                    that.$message.error(res.msg);
                } else {
                    that.bankInfo = res.data;
                }
            })
        },
        getIdentifyCodeImg() {
            let that = this;
            let params = {};
            getIdentifyCode(params).then((res) => {
                that.imgsrc = 'data:image/png;base64,' + res.imgsrc;
            })
        },
        refreshCaptcha() {
            this.getIdentifyCodeImg();
        },
        checkCaptchaImg(formName) {
            let that = this;
            if(that.second < 60) {
                return;
            }
            let flage = true;
            that.checkCaptcha = true;
            that.$refs[formName].validateField('captcha', error => {
                if (error) {
                    flage = false;
                    that.$message.error(error);
                }
            });
            if (!flage) {
                return;
            }
            that.$refs[formName].validateField('phone', error => {
                if (error) {
                    flage = false;
                    that.$message.error(error);
                }
            });
            if (flage) {
                let params = {
                    merchantId: that.merchantId,
                    phone: that.ruleForm.phone,
                    imgCaptcha: that.ruleForm.captcha,
                    type: "3"
                };
                sendMsgCode(params).then((res) => {
                    that.checkCaptcha = false;
                    if (res.code !== 200) {
                        that.getIdentifyCodeImg();
                        that.$message.error(res.msg);
                    } else {
                        that.getCode();
                    }
                })
            } else {
                that.checkCaptcha = false;
            }
        },
        getCode() {
            let that = this;
            if (!that.timer && that.second == that.totalSecond) {
                // 开启倒计时
                that.timer = setInterval(() => {
                    that.second--
                    if (that.second <= 0) {
                        clearInterval(that.timer)
                        that.timer = null // 重置定时器 id
                        that.second = that.totalSecond//归位
                    }
                }, 1000)
                that.$message.success('发送成功,请注意查收')
            }
        },
        toBack() {
            this.$router.go(-1);
        }
    }
}
</script>
<style scoped>
.content {
    min-height: 100vh;
    background-color: #fafafa;
}

.bind-content {
    overflow: hidden;
}

.input-each-div {
    position: relative;
    padding: 5px 15px;
    margin-bottom: 1px;
    background-color: #fff;
}

.tips-div {
    padding: 10px 15px;
    font-size: 12px;
    color: #999999;
    text-align: left;
}

.input-each-div :deep(.el-input__inner) {
    padding: 0;
    border: 0;
}

.tips-text-content {
    padding: 15px 11px 15px 18px;
    text-align: left;
    margin-bottom: 1px;
    background-color: #fff;
}

.tips-text {
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #0095D9;
}

.captchaImg {
    position: absolute;
    width: 70px;
    height: 30px;
    right: 0;
    top: 50%;
    margin-top: -15px;
}

.sendBtn {
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -12px;
    min-width: 70px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #0095D9;
    letter-spacing: 0;
}

.all-btn {
    margin-top: 75px;
    padding: 0 40px;
    overflow: hidden;
}

.over-btn {
    height: 44px;
    line-height: 44px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    font-weight: 500;
    background: #0095D9;
    border-radius: 32px;
}

.bind-icon {
    padding: 46px 0 40px 0;
    font-size: 14px;
    color: #333333;
    text-align: center;
}

.bind-icon img {
    margin-bottom: 20px;
    width: 48px;
    height: 48px;
}

.bind-info {
    margin: 0 20px;
    background: #F5F5F5;
    text-align: left;
    border-radius: 5px;
}

.bind-info-detail {
    padding: 20px 15px 0 15px;
    border-bottom: 1px solid #E5E5E5;
    overflow: hidden;
}

.bind-info-each {
    margin-bottom: 15px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    font-weight: 500;
}

.bind-reset-btn {
    line-height: 35px;
    text-align: center;
    font-family: PingFangSC-Medium;
    font-size: 12px;
    color: #0095D9;
    letter-spacing: 0;
    font-weight: 500;
}
</style>